export enum NotStartedSelections {
  TRUE = 'true',
  FALSE = 'false',
}
